import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

// Map of old URLs to new URLs for proper SEO redirects
const redirectMap = {
  // Old service pages
  '/services-carte-grise': '/carte-grise',
  '/services-carte-grise/': '/carte-grise',
  '/assurance-du-particulier': '/services',
  '/assurance-du-particulier/': '/services',
  '/contact-cambc': '/contact',
  '/contact-cambc/': '/contact',
  '/assurance-professionnelle': '/services',
  '/assurance-professionnelle/': '/services',
  
  // Old Courtigo quote URLs - redirect to unified quote page
  '/devis-auto': '/quote?type=auto',
  '/devis-auto/': '/quote?type=auto',
  '/devis-moto': '/quote?type=moto',
  '/devis-moto/': '/quote?type=moto',
  '/devis-animaux': '/quote',
  '/devis-animaux/': '/quote',
  '/devis-sante': '/quote?type=sante',
  '/devis-sante/': '/quote?type=sante',
  '/devis-habitation': '/quote?type=habitation',
  '/devis-habitation/': '/quote?type=habitation',
  '/devis-decennale': '/quote?type=decennale',
  '/devis-decennale/': '/quote?type=decennale',
  '/devis-emprunteur': '/quote',
  '/devis-emprunteur/': '/quote',
};

export const RedirectHandler = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname;
    
    // Check if current path needs redirect
    if (redirectMap[currentPath]) {
      // Use replace to avoid creating browser history entry
      navigate(redirectMap[currentPath], { replace: true });
      return;
    }

    // Handle trailing slashes (redirect /page/ to /page) except for root
    if (currentPath !== '/' && currentPath.endsWith('/')) {
      navigate(currentPath.slice(0, -1), { replace: true });
    }
  }, [location.pathname, navigate]);

  return null;
};
